<ng-template #progressSpinnerRef>
  <mat-progress-spinner diameter="100" mode="indeterminate" value="50"> </mat-progress-spinner>
</ng-template>
